import MDBox from 'components/MDBox';
import DashboardLayout from 'examples/LayoutContainers/DashboardLayout';
import DashboardNavbar from 'examples/Navbars/DashboardNavbar';
import DashboardOverview from 'components/DashboardOverview';
import React from 'react';

const Dashboard = () => {
    return (
        <DashboardLayout>
            <DashboardNavbar />
            <MDBox pt={4} pb={3} px={3}>
                <DashboardOverview />
            </MDBox>
        </DashboardLayout>
    );
};

export default Dashboard;